import * as React from 'react'
import { Form, Input, Tabs, Spin } from 'antd'
import { cloneDeep, get } from 'lodash'
import { showError } from 'helpers/errors'
import { createLabelFactory } from 'helpers/formViews'
import { formatUserTime } from 'helpers/dateTime'
import { t } from 'helpers/i18n'
import { stopEvent } from 'helpers/events'
import FormButtons from 'elements/FormButtons'
import LocationCountItems from 'containers/LocationCounts/Items'
import { Row, Col } from 'elements/Grid'

class FormView extends React.Component {
  state = {}

  componentDidMount() {
    this.fetchItem()

    // Emitter.on(FORM_CHANGE_EVENT, this.handleFormChange)
  }

  componentWillUnmount() {
    // Emitter.off(FORM_CHANGE_EVENT, this.handleFormChange)
  }

  getItemId = () => [this.state.item?.id, this.props.linkTargetRecord?.locationCountId].find(Boolean)

  fetchItem = async ({ itemId = this.getItemId() } = {}) => {
    try {
      const responses = await Promise.all([
        this.props.getItem(itemId).catch((error) => {
          this.props.onCancel?.()
          throw error
        }),
        this.props.getSettings({ type: this.props.settingsType }),
        this.props.getDetailItems(itemId),
      ])

      const item = cloneDeep(responses[0].value.data)

      this.setState({
        item,
        itemOriginal: cloneDeep(item),
        fieldSettings: get(responses[1], 'value.data.fieldSettings', []),
        detailItems: get(responses[2], 'value.data.items', []),
        detailItemsOriginal: get(responses[2], 'value.data.items', []),
        detailItemsTotals: get(responses[2], 'value.data.pageTotals', []),
      })
    } catch (error) {
      showError({ error })
    }
  }

  render() {
    const { item, fieldSettings } = this.state

    if (!item || !fieldSettings) {
      return <Spin />
    }

    const createLabel = createLabelFactory(fieldSettings)

    // console.log({ item, fieldSettings })

    return (
      <Form layout="vertical" colon={false} onSubmit={stopEvent}>
        <div className="form-items-container">
          <Row>
            <Col third>
              <Form.Item label={createLabel('locationName')}>
                <Input value={item.locationName} disabled />
              </Form.Item>
            </Col>
            <Col third>
              <Form.Item label={t('created')}>
                <Input value={formatUserTime(item.createdDate, item.createdBy)} disabled />
              </Form.Item>
            </Col>
            <Col third>
              <Form.Item label={createLabel('statusDescription')}>
                <Input value={item.statusDescription} disabled />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            activeKey={this.state.tabsActiveKey || 'items'}
            onChange={(value) => this.setState({ tabsActiveKey: value })}
          >
            <Tabs.TabPane key="locationCount" tab={t('locationCount')} forceRender>
              <Row>
                <Col third>
                  <Form.Item label={createLabel('itemsAtLocation')}>
                    <Input value={item.itemsAtLocation} disabled />
                  </Form.Item>
                </Col>
                <Col third>
                  <Form.Item label={t('completed')}>
                    <Input value={formatUserTime(item.completedDate, item.userName)} disabled />
                  </Form.Item>
                </Col>
                <Col third>
                  <Form.Item label={createLabel('elapsedTimeFromCreateToComplete')}>
                    <Input value={item.elapsedTimeFromCreateToComplete} disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col third>
                  <Form.Item label={createLabel('itemsCounted')}>
                    <Input value={item.itemsCounted} disabled />
                  </Form.Item>
                </Col>
                <Col third>
                  <Form.Item label={t('committed')}>
                    <Input value={formatUserTime(item.committedDate, item.committedBy)} disabled />
                  </Form.Item>
                </Col>
                <Col third>
                  <Form.Item label={createLabel('elapsedTimeFromCompleteToCommit')}>
                    <Input value={item.elapsedTimeFromCompleteToCommit} disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col third>
                  <Form.Item label={createLabel('itemsAdjusted')}>
                    <Input value={item.itemsAdjusted} disabled />
                  </Form.Item>
                </Col>
                <Col third>
                  <Form.Item label={t('exported')}>
                    <Input value={formatUserTime(item.exportedDate, item.exportedBy)} disabled />
                  </Form.Item>
                </Col>
                <Col third>
                  <Form.Item label={createLabel('elapsedTimeFromCommitToExport')}>
                    <Input value={item.elapsedTimeFromCommitToExport} disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col third>
                  <Form.Item label={createLabel('itemsOrdered')}>
                    <Input value={item.itemsOrdered} disabled />
                  </Form.Item>
                </Col>
                <Col third>
                  <Form.Item label={createLabel('orderId')}>
                    <Input value={item.orderId ? item.orderId : ''} disabled />
                  </Form.Item>
                </Col>
                <Col third>
                  <Form.Item label={createLabel('orderStatusDescription')}>
                    <Input value={item.orderStatusDescription} disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col third>
                  <Form.Item label={createLabel('inventoryUpdateStatusDescription')}>
                    <Input value={item.inventoryUpdateStatusDescription} disabled />
                  </Form.Item>
                </Col>
                <Col twoThirds>
                  <Form.Item label={createLabel('inventoryTransferLogComment')}>
                    <Input.TextArea rows={3} value={item.inventoryTransferLogComment} disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col third>
                  <Form.Item label={createLabel('orderCreateStatusDescription')}>
                    <Input value={item.orderCreateStatusDescription} disabled />
                  </Form.Item>
                </Col>
                <Col twoThirds>
                  <Form.Item label={createLabel('orderTransferLogComment')}>
                    <Input.TextArea rows={3} value={item.orderTransferLogComment} disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane key="items" tab={t('items')} forceRender>
              <LocationCountItems
                parentRecord={item}
                items={this.state.detailItems ?? []}
                originals={this.state.detailItemsOriginal ?? []}
                pageTotals={this.state.detailItemsTotals ?? {}}
                onChange={(values) => this.setState({ detailItems: values })}
                onTableExtraButtonsClick={this.handleItemsTableExtraButtonsClick}
                readOnly
              />
            </Tabs.TabPane>
          </Tabs>
        </div>
        <div className="form-buttons-container">
          <div className="float-right text-right">
            <FormButtons
              onCancel={this.props.onCancel}
              onSubmit={this.handleSubmit}
              saveButtonLoading={this.state.saveButtonLoading}
              saveAndCloseButtonLoading={this.state.saveAndCloseButtonLoading}
              readOnly
            />
          </div>
        </div>
      </Form>
    )
  }
}

export default FormView
